import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const TooltipCell = ({ text, maxWidth = 150 }) => {
    const textRef = React.useRef(null);
    const [isTruncated, setIsTruncated] = React.useState(false);

    React.useEffect(() => {
        if (textRef.current) {
            setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
        }
    }, [text]);

    const content = (
        <div
            ref={textRef}
            style={{
                maxWidth: `${maxWidth}px`,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
            }}
        >
            {text || "—"}
        </div>
    );

    if (!isTruncated || !text) {
        return content;
    }

    return (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-${text}`}>{text}</Tooltip>}
        >
            <div
                style={{
                    maxWidth: `${maxWidth}px`,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    cursor: "pointer",
                }}
            >
                {text}
            </div>
        </OverlayTrigger>
    );
};

export default TooltipCell;
